/** Latencia artificial para ejercitar estados loading en demo. */
export function delay(ms = 180): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}
